namespace SolovisGateway.Admin.DbServers {

    /**
     * AdminDbServerListControl presents the user interface for administratinge database servers.
     */
    export class AdminDbServerListControl extends Solovis.UI.BaseControl {

        private _dbServerList;
        private _initError;

        private _toolbarContainer;
        private _toolbar: Solovis.UI.Toolbar;

        private _dataGrid: DevExpress.ui.dxDataGrid;

        constructor(options) {
            super(options);
        }

        public doInitAsync() {
            let self = this;

            Solovis.Rpc.invokeAndWait(
                "~/Rpc/DbServers/GetDbServers",
                {},
                function (response, success) {
                    if (success) {
                        self._dbServerList = response.result.dbServers;
                    }
                    else {
                        console.log("ERROR: AdminDbServerListControl.doInitAsync");
                        console.log(response.error);
                        self._initError = response.error;
                    }

                    self.notifyInitComplete();
                });
        }

        public doRender() {
            let self = this;

            this._toolbarContainer = $("<div>").appendTo(this.container);

            var toolbar = new Solovis.UI.Toolbar({
                container: this._toolbarContainer
            });
            this._toolbar = toolbar;

            toolbar.addItem({
                name: "addEnvironmentPoolButton",
                createToolbarItem: function () {
                    var addEnvironmentPoolButton = new Solovis.UI.Buttons.Button({
                        element: $("<div>").text("Add Database Server").prepend($("<span>").css("padding-right", "5px").addClass("fa fa-plus")),
                        size: "small",
                        click: function () {
                            self._showAddDbServerInterface({
                                saveCallback: function () {
                                    self._refreshDbServers();
                                }
                            });
                        }
                    });

                    return addEnvironmentPoolButton;
                }
            });

            toolbar.addItem({
                name: "viewAllDbButton",
                createToolbarItem: function () {
                    var viewAllDbButton = new Solovis.UI.Buttons.Button({
                        element: $("<div>").text("View All Databases"),
                        size: "small",
                        click: function () {                           
                            window.location.href = Solovis.resolveUrl("~/Admin/DbServerAdmin/AllDatabases");                                
                        }
                    });

                    return viewAllDbButton;
                }
            });

            toolbar.addItem({
                name: "viewAllElasticPoolButton",
                createToolbarItem: function () {
                    var viewAllElasticPoolButton = new Solovis.UI.Buttons.Button({
                        element: $("<div>").text("View All Elastic Pools"),
                        size: "small",
                        click: function () {
                            window.location.href = Solovis.resolveUrl("~/Admin/DbServerAdmin/AllElasticPools");
                        }
                    });

                    return viewAllElasticPoolButton;
                }
            });

            // Setup data grid
            let dataGridContainer = $("<div>").appendTo(this.container);

            let store = new DevExpress.data.ArrayStore({
                key: 'id',
                data: this._dbServerList
            });

            dataGridContainer.dxDataGrid({
                dataSource: {
                    store: store,
                    sort: 'name'
                },

                allowColumnResizing: true,
                allowColumnReordering: true,
                rowAlternationEnabled: true,
                searchPanel: { visible: true },
                columnChooser: { enabled: true },

                width: "100%",

                columns: [
                    {
                        caption: "Actions",
                        allowSorting: false,
                        cellTemplate: function (container, options) {
                            let envData = options.data;
                            self._buildActionsCell(container, envData);
                        },
                        width: 75
                    },
                    {
                        dataField: 'server',
                        dataType: 'string',
                        caption: 'Server',
                        allowSorting: true,
                        width: 200
                    },
                    {
                        dataField: 'isSqlAzure',
                        dataType: 'boolean',
                        caption: 'SQL Azure',
                        visible: true,
                        allowSorting: true,
                        width: 75
                    },
                    {
                        dataField: 'id',
                        dataType: 'number',
                        caption: 'Database Server Id',
                        visible: false,
                        allowSorting: true,
                        width: 150
                    }
                ]
            });

            this._dataGrid = dataGridContainer.dxDataGrid("instance");
        }

        private _showAddDbServerInterface(options) {
            let self = this;

            let editDialog = new EditDbServerDialog({
                dbServerId: options.dbServerId,
                saveCallback: function () {
                    self._refreshDbServers();
                }
            });
            editDialog.show();
        }


        private _buildActionsCell(container, dbServerData) {
            let self = this;
            let columnDiv = container;

            let editDbServerLink = $("<a>").appendTo(columnDiv);
            $("<span class='fa fa-pencil'>").appendTo(editDbServerLink);
            editDbServerLink.attr("title", "Edit Database Server");
            editDbServerLink.click(function () {
                self._showAddDbServerInterface({ dbServerId: dbServerData.id });
            });     

            let deleteDbServerLink = $("<a>").css("padding-left", "20px").appendTo(columnDiv);
            $("<span class='fa fa-remove'>").appendTo(deleteDbServerLink);
            deleteDbServerLink.attr("title", "Edit Database Server");
            deleteDbServerLink.click(function () {
                self._showDeleteDbServerPrompt(dbServerData);
            });         
        }


        private _refreshDbServers() {
            let self = this;

            Solovis.Rpc.invokeAndWait(
                "~/Rpc/DbServers/GetDbServers",
                {},
                function (response, success) {
                    if (success) {
                        let dbServers = response.result.dbServers;
                        self._dbServerList = dbServers;

                        let store = new DevExpress.data.ArrayStore({ key: 'id', data: dbServers });

                        self._dataGrid.option("dataSource", store);
                    }
                });
        }


        private _showDeleteDbServerPrompt(dbServerData)
        {
            let self = this;

            Solovis.UI.confirm(
                "Remove database server? Server will not actually be deleted, but it will not be tracked here anymore.",
                "Remove Database Server",
                function (confirmed) {
                if (confirmed) {
                    Solovis.Rpc.invokeAndWait(
                        "~/Admin/DbServerAdmin/DeleteDbServer",
                        { dbServerId: dbServerData.id },
                        function (response, success) {
                            if (success) {
                                self._refreshDbServers();
                            }
                        });
                }
            });
        }
    }
}